import { jsx } from '@emotion/react/jsx-runtime';
import { createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { useCss } from '@nettbureau/styling';
import { useCardContext } from './card-context.js';

/**
 * Card body is the main content of a card. It adds an inner spacing to the card content. While it's
 * not required to use a card body when using cards, it's recommended to use it to add some padding
 * to the card content.
 */ const CardBody = createPolymorphicComponent((props, ref)=>{
    const cardContext = useCardContext();
    const [mergedProps, mergedRef] = useSlot('CardBody', props, ref);
    const { as: Component = 'div', children, className, css, layout, padding = cardContext?.padding } = mergedProps;
    const cardBodyCss = useCss(({ mixins })=>[
            mixins.flexItem({
                grow: true
            }),
            mixins.spacing({
                padding
            }),
            layout && mixins.flex({
                direction: 'vertical',
                ...layout
            })
        ]);
    return /*#__PURE__*/ jsx(Component, {
        "data-card-body": true,
        ref: mergedRef,
        className: className,
        css: [
            cardBodyCss,
            css
        ],
        children: children
    });
});

export { CardBody };
//# sourceMappingURL=card-body.js.map
